import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';
import i18n from '../i18n';

// The API's own words, when it gave any. A toast times out, so a form that must be
// corrected before it can be resubmitted needs to keep the reason on screen too.
export function requestErrorDetail(error: unknown): string | null {
  const detail = (error as { detail?: unknown })?.detail;
  return typeof detail === 'string' && detail ? detail : null;
}

export function showRequestError(error: unknown, context?: string): void {
  const err = error instanceof Error ? error : new Error(String(error) || 'Unknown error');

  if (err.name === 'AbortError') return;

  // the toast is deliberately generic, so keep the real cause reachable in the console
  console.error('[request failed]', context ?? '', err);

  if (err.name === 'TimeoutError') {
    const message = context
      ? i18n.t('{{context}} request timed out. Please try again.', { context })
      : i18n.t('Request timed out. Please try again later.');
    toast.error(message);
    Sentry.captureException(err, {
      tags: { type: 'request_timeout' },
      extra: { context },
    });
    return;
  }

  // an API that explained itself is worth quoting: the caller cannot act on
  // "could not be loaded" when the real answer is which file was rejected and why
  const detail = requestErrorDetail(error);
  if (detail) {
    toast.error(detail);
    return;
  }

  const message = context
    ? i18n.t('{{context}} could not be loaded. Please try again.', { context })
    : i18n.t('We could not process your request. Please try again.');
  toast.error(message);
}
